import * as tslib_1 from "tslib";
import { AfterViewInit, ViewContainerRef } from '@angular/core';
import { BooleanConverter, InputConverter, JSONConverter, NumberConverter } from '../../../inputConverter';
import { LogLevel } from '../../../types';
import { BaseComponent } from '../../base.component';
var ApplicationMessagesComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ApplicationMessagesComponent, _super);
    function ApplicationMessagesComponent(_vcr) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.notificationLevels = [LogLevel.Info, LogLevel.Warn, LogLevel.Error];
        _this.showPrivate = false;
        _this.durationInMs = 5000;
        _this.activeNotifications = [];
        _this.uniqueMessageId = 0;
        _this.spliceCount = 1;
        return _this;
    }
    ApplicationMessagesComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                window.addEventListener('applicationMessage', function (notification) {
                    var detail = notification.detail;
                    if (_this.showPrivate && _this.notificationLevels.includes(detail.level)) {
                        _this.addMessageToList(detail);
                    }
                    else if (!detail.isPrivate && _this.notificationLevels.includes(detail.level)) {
                        _this.addMessageToList(detail);
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    ApplicationMessagesComponent.prototype.addMessageToList = function (detail) {
        var _this = this;
        detail.message = detail.level === LogLevel.Fatal ? 'A fatal error has occurred, please refresh application.' : detail.message;
        detail.uniqueId = this.uniqueMessageId;
        this.uniqueMessageId++;
        if (detail.level <= LogLevel.Debug) {
            detail.alertClass = 'alert';
        }
        if (detail.level === LogLevel.Info) {
            detail.alertClass = 'alert-green';
        }
        if (detail.level === LogLevel.Warn) {
            detail.alertClass = 'alert-yellow';
        }
        if (detail.level >= LogLevel.Error) {
            detail.alertClass = 'alert-red';
        }
        this.activeNotifications.push(detail);
        setTimeout(function () {
            var index = _this.activeNotifications.findIndex(function (x) { return x.uniqueId === detail.uniqueId; });
            _this.activeNotifications.splice(index, _this.spliceCount);
        }, this.durationInMs);
    };
    ApplicationMessagesComponent.prototype.hideNotification = function (index) {
        this.activeNotifications.splice(index, this.spliceCount);
    };
    tslib_1.__decorate([
        InputConverter(JSONConverter),
        tslib_1.__metadata("design:type", Array)
    ], ApplicationMessagesComponent.prototype, "notificationLevels", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Object)
    ], ApplicationMessagesComponent.prototype, "showPrivate", void 0);
    tslib_1.__decorate([
        InputConverter(NumberConverter),
        tslib_1.__metadata("design:type", Object)
    ], ApplicationMessagesComponent.prototype, "durationInMs", void 0);
    return ApplicationMessagesComponent;
}(BaseComponent));
export { ApplicationMessagesComponent };
